import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { MERCURY_ENV, SENTRY_DSN } from '@/constants/env';

Sentry.init({
  dsn: SENTRY_DSN,
  release: process.env.MERCURY_VERSION,
  environment: MERCURY_ENV,
  tunnel: '/api/sentry-tunnel',
  debug: MERCURY_ENV === 'STAGING',
  enabled: MERCURY_ENV !== 'DEV' && MERCURY_ENV !== 'TEST',
  ignoreErrors: [
    // Benign browser notification (see ResizeObserver spec) emitted by components
    // that reposition on resize; it has no user impact and is also swallowed from
    // the dev overlay via suppressResizeObserverLoopError.
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
    // Browsers with a stale service worker registration from earlier PWA
    // experimentation retry the install forever until public/sw.js (a
    // self-unregistering kill switch) reaches them; safe to ignore in the
    // meantime (see Sentry issue MERCURY-5A).
    'encountered an error during installation',
  ],
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
});
